import React, { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../translations";

export const Process = () => {
  const [activeStep, setActiveStep] = useState(1);
  const { language } = useLanguage();
  const t = translations.process[language] || translations.process.en;

  const processSteps = [
    {
      id: 1,
      title: t.step1.title,
      subtitle: language === 'en' ? "Understanding Your Vision" : 
               language === 'hi' ? "आपकी दृष्टि को समझना" : 
               language === 'pa' ? "ਤੁਹਾਡੀ ਦ੍ਰਿਸ਼ਟੀ ਨੂੰ ਸਮਝਣਾ" : 
               "Comprendre Votre Vision",
      description: t.step1.desc,
      items: language === 'en' ? [
        "Business & Process Analysis",
        "Technology Stack Selection", 
        "Project Roadmap & Timeline",
        "Cost Estimation"
      ] : language === 'hi' ? [
        "व्यापार और प्रक्रिया विश्लेषण",
        "टेक्नोलॉजी स्टैक चयन", 
        "प्रोजेक्ट रोडमैप और टाइमलाइन",
        "लागत अनुमान"
      ] : language === 'pa' ? [
        "ਕਾਰੋਬਾਰ ਅਤੇ ਪ੍ਰਕਿਰਿਆ ਵਿਸ਼ਲੇਸ਼ਣ",
        "ਟੈਕਨੋਲੋਜੀ ਸਟੈਕ ਚੋਣ", 
        "ਪ੍ਰੋਜੈਕਟ ਰੋਡਮੈਪ ਅਤੇ ਟਾਈਮਲਾਈਨ",
        "ਲਾਗਤ ਅਨੁਮਾਨ"
      ] : [
        "Analyse Business & Processus",
        "Sélection Stack Technologique", 
        "Feuille de Route Projet",
        "Estimation des Coûts"
      ]
    },
    {
      id: 2,
      title: t.step2.title,
      subtitle: language === 'en' ? "Blueprinting Your Solution" : 
               language === 'hi' ? "आपके समाधान की ब्लूप्रिंटिंग" : 
               language === 'pa' ? "ਤੁਹਾਡੇ ਹੱਲ ਦੀ ਬਲੂਪ੍ਰਿੰਟਿੰਗ" : 
               "Concevoir Votre Solution",
      description: t.step2.desc,
      items: language === 'en' ? [
        "UI/UX Design & Prototyping",
        "System Architecture Design",
        "Database & API Planning",
        "Security Framework"
      ] : language === 'hi' ? [
        "UI/UX डिज़ाइन और प्रोटोटाइपिंग",
        "सिस्टम आर्किटेक्चर डिज़ाइन",
        "डेटाबेस और API प्लानिंग",
        "सुरक्षा फ्रेमवर्क"
      ] : language === 'pa' ? [
        "UI/UX ਡਿਜ਼ਾਈਨ ਅਤੇ ਪ੍ਰੋਟੋਟਾਈਪਿੰਗ",
        "ਸਿਸਟਮ ਆਰਕੀਟੈਕਚਰ ਡਿਜ਼ਾਈਨ",
        "ਡੇਟਾਬੇਸ ਅਤੇ API ਪਲੈਨਿੰਗ",
        "ਸੁਰੱਖਿਆ ਫਰੇਮਵਰਕ"
      ] : [
        "Design UI/UX & Prototypage",
        "Architecture Système",
        "Planification Base de Données & API",
        "Cadre de Sécurité"
      ]
    },
    {
      id: 3,
      title: t.step3.title,
      subtitle: language === 'en' ? "Building Your Product" : 
               language === 'hi' ? "आपके उत्पाद का निर्माण" : 
               language === 'pa' ? "ਤੁਹਾਡੇ ਉਤਪਾਦ ਦਾ ਨਿਰਮਾਣ" : 
               "Construire Votre Produit",
      description: t.step3.desc,
      items: language === 'en' ? [
        "Agile Sprint Development",
        "Continuous Integration",
        "Quality Assurance Testing",
        "Regular Progress Updates"
      ] : language === 'hi' ? [
        "एजाइल स्प्रिंट डेवलपमेंट",
        "कंटीन्यूअस इंटीग्रेशन",
        "क्वालिटी एश्योरेंस टेस्टिंग",
        "नियमित प्रगति अपडेट"
      ] : language === 'pa' ? [
        "ਐਜਾਇਲ ਸਪ੍ਰਿੰਟ ਡਿਵੈਲਪਮੈਂਟ",
        "ਕੰਟੀਨਿਊਅਸ ਇੰਟੀਗ੍ਰੇਸ਼ਨ",
        "ਕੁਆਲਿਟੀ ਐਸ਼ੋਰੈਂਸ ਟੈਸਟਿੰਗ",
        "ਨਿਯਮਤ ਪ੍ਰਗਤੀ ਅੱਪਡੇਟ"
      ] : [
        "Développement Sprint Agile",
        "Intégration Continue",
        "Tests d'Assurance Qualité",
        "Mises à Jour Régulières"
      ]
    },
    {
      id: 4,
      title: t.step4.title,
      subtitle: language === 'en' ? "Going Live & Beyond" : 
               language === 'hi' ? "लॉन्च और उसके बाद" : 
               language === 'pa' ? "ਲੌਂਚ ਅਤੇ ਇਸ ਤੋਂ ਅੱਗੇ" : 
               "Mise en Ligne & Au-delà",
      description: t.step4.desc,
      items: language === 'en' ? [
        "Deployment & Go-Live",
        "User Training & Documentation",
        "Performance Monitoring",
        "Ongoing Maintenance"
      ] : language === 'hi' ? [
        "डिप्लॉयमेंट और गो-लाइव",
        "यूजर ट्रेनिंग और डॉक्युमेंटेशन",
        "परफॉर्मेंस मॉनिटरिंग",
        "निरंतर मेंटेनेंस"
      ] : language === 'pa' ? [
        "ਡਿਪਲੋਇਮੈਂਟ ਅਤੇ ਗੋ-ਲਾਈਵ",
        "ਯੂਜ਼ਰ ਟ੍ਰੇਨਿੰਗ ਅਤੇ ਡੌਕਯੂਮੈਂਟੇਸ਼ਨ",
        "ਪਰਫਾਰਮੈਂਸ ਮਾਨੀਟਰਿੰਗ",
        "ਨਿਰੰਤਰ ਮੇਂਟੇਨੈਂਸ"
      ] : [
        "Déploiement & Mise en Ligne",
        "Formation & Documentation",
        "Surveillance Performance",
        "Maintenance Continue"
      ]
    }
  ];

  return (
    <section id="process">
      <div className="container">
        <div className="section-header">
          <span className="section-label">{t.title}</span>
          <h2 className="section-title">{t.title}</h2>
          <p className="section-description">
            {t.subtitle}
          </p>
        </div>
        
        <div className="process-container">
          <div className="process-tabs">
            {processSteps.map((step) => (
              <button
                key={step.id}
                className={`process-tab ${activeStep === step.id ? 'active' : ''}`}
                onClick={() => setActiveStep(step.id)}
              >
                <span className="tab-number">0{step.id}</span>
                <span className="tab-title">{step.title}</span>
              </button>
            ))}
          </div>
          
          <div className="process-content">
            {processSteps.map((step) => (
              <div
                key={step.id}
                className={`process-panel ${activeStep === step.id ? 'active' : ''}`}
              >
                <div className="panel-header">
                  <span className="panel-number">{language === 'fr' ? 'Phase' : language === 'hi' ? 'चरण' : language === 'pa' ? 'ਪੜਾਅ' : 'Phase'} {step.id}</span>
                  <h3>{step.title}</h3>
                  <p className="panel-subtitle">{step.subtitle}</p>
                </div>
                <p className="panel-description">{step.description}</p>
                <ul className="panel-items">
                  {step.items.map((item, i) => (
                    <li key={i}>
                      <span className="check">✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
